export enum ResponsibilityLetterQueryKeys {
  RESPONSIBILITY_LETTER_STATE = 'responsibilityLetterState',
  HISTORY_RESPONSIBILITY_LETTER_STATE = 'historyResponsibilityLetterState',
}
